import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Table from '../../components/Common/Table';
import Button from '../../components/Common/Button';
import api from '../../utils/api';
import { showDeleteConfirm, showSuccess, showError } from '../../utils/swal';
import { Plus } from 'lucide-react';

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await api.get('/projects');
      setProjects(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Projeler yüklenemedi:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (row) => {
    const result = await showDeleteConfirm(`"${row.name}" projesi`);
    if (!result.isConfirmed) {
      return;
    }

    try {
      await api.delete(`/projects/${row.id}`);
      fetchProjects();
      showSuccess('Proje başarıyla silindi!');
    } catch (error) {
      console.error('Proje silinemedi:', error);
      showError('Proje silinirken bir hata oluştu', 'Silme Hatası');
    }
  };

  const columns = [
    {
      header: 'Proje Adı',
      accessor: 'name',
      render: (row) => (
        <span
          className="text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-blue-400 cursor-pointer font-medium"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/projects/${row.id}`);
          }}
        >
          {row.name}
        </span>
      )
    },
    { header: 'Konum', accessor: 'location' },
    { header: 'Proje Sahibi', accessor: 'owner' },
    {
      header: 'Gayrimenkul Sayısı',
      accessor: 'portfolios',
      render: (row) => row.portfolios?.length || 0
    },
  ];

  if (loading) {
    return <div className="text-center py-8">Yükleniyor...</div>;
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Projeler</h1>
        <Button onClick={() => navigate('/projects/new')}>
          <Plus size={18} />
          Yeni Proje
        </Button>
      </div>

      <Card noPadding>
        <Table
          columns={columns}
          data={projects}
          onView={(row) => navigate(`/projects/${row.id}`)}
          onEdit={(row) => navigate(`/projects/${row.id}/edit`)}
          onDelete={handleDelete}
        />
      </Card>
    </div>
  );
};

export default ProjectList;
